<template>
	<div :class="{ puzzle: value }">
    <img @click="$emit('input', '')" _cursor="pointer" _pos="absolute" _right="8px" _top="8px" width="30px" height="30px" :src="require('@/assets/image/delete1.3.1.png')" v-if="value"/>
		<div v-show="value" class="puzzle-board" @click="upload" />
		<upload-pic ref="upload" v-show="!value" v-model="pic" />
	</div>
</template>

<script>
import uploadPic from './uploadPic.vue'
import { createPuzzlePieces } from '@/utils/puzzle'

export default {
	props: {
		num: {
			type: Number,
			required: true,
			default: 4
		},
		value: {
			type: String,
			required: true,
			default: ''
		}
	},
	components: {
		uploadPic
	},
	computed: {
		sqrt() {
			return Math.sqrt(this.num)
		},
		pic: {
			get() {
				return this.value
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	},
	watch: {
		value: {
			handler(value) {
				if (value) this.createPuzzlePieces()
			},
			immediate: true
		},
		num() {
			if (this.value) this.createPuzzlePieces()
		}
	},
	methods: {
		/** 上传 */
		upload() {
			this.$refs.upload?.$refs?.input?.click()
		},

		/** 创建拼图块 */
		async createPuzzlePieces() {
			await this.$nextTick()
			const board = document.querySelector('.puzzle-board')
			createPuzzlePieces(board, 450, this.num, this.value)
		}
	}
}
</script>

<style>
.puzzle-board {
	display: flex;
	flex-wrap: wrap;
	cursor: pointer;
}
.puzzle{
  display: flex;
  justify-content: center;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 3px;
}
</style>
